import { computed, Injectable, Signal, inject } from "@angular/core";
import { AppConfigService } from "@api/services/app-config.service";
import { AuthConfig } from "angular-oauth2-oidc";

@Injectable({
    providedIn: "root",
})
export class AuthConfigService {
    private readonly appConfigService = inject(AppConfigService);
    private readonly appConfig = this.appConfigService.appConfig;

    authConfig: Signal<AuthConfig> = computed(() => ({
        issuer: this.appConfig().identityServer,
        tokenEndpoint: `${this.appConfig().identityServer}/connect/token`,
        redirectUri: window.location.origin + "/signin-callback",
        postLogoutRedirectUri: window.location.origin + "/signout-callback",
        clientId: this.appConfig().identityServerClientId,
        responseType: "code",
        scope: "offline_access Azara.acw Azara.reporting profile",
        showDebugInformation: true,
        silentRefreshRedirectUri: window.location.origin + "/silent-refresh.html",
        customQueryParams: {
            client_assertion_type: "urn:ietf:params:oauth:client-assertion-type:jwt-bearer",
        },
    }));
}
